import { Node, mergeAttributes } from '@tiptap/core';
const LIST_NODE_NAME = 'fileAttachmentList';
const LIST_TAG_NAME = 'mb-file-attachment-list';
const LIST_ITEM_NODE_NAME = 'fileAttachmentListItem';
const LIST_ITEM_TAG_NAME = 'mb-file-attachment-list-item';
export const FileAttachmentListItem = Node.create({
    name: LIST_ITEM_NODE_NAME,
    group: LIST_NODE_NAME,
    addCommands() {
        return {
            addFileAttachmentsListItem: (attrs) => ({ commands }) => {
                return commands.insertContent({
                    type: this.name,
                    attrs,
                });
            },
        };
    },
    renderHTML({ HTMLAttributes }) {
        return [LIST_ITEM_TAG_NAME, mergeAttributes(HTMLAttributes)];
    },
    parseHTML() {
        return [
            {
                tag: LIST_ITEM_TAG_NAME,
            },
        ];
    },
    addAttributes() {
        return {
            userAssetUUID: {
                default: '',
                renderHTML(attrs) {
                    return { ...attrs, 'data-user-asset-uuid': attrs.userAssetUUID };
                },
                parseHTML(element) {
                    const attr = element.getAttribute('data-user-asset-uuid') ?? '';
                    return attr;
                },
            },
            fileName: {
                default: '',
                renderHTML(attrs) {
                    return { ...attrs, 'data-user-asset-filename': attrs.fileName };
                },
                parseHTML(element) {
                    const attr = element.getAttribute('data-user-asset-fileName') ?? '';
                    return attr;
                },
            },
            bytes: {
                default: 0,
                renderHTML(attrs) {
                    return {
                        ...attrs,
                        'data-user-asset-filename': attrs.bytes?.toString(),
                    };
                },
                parseHTML(element) {
                    const attr = element.getAttribute('data-user-asset-fileName') ?? '';
                    const bytes = attr ? parseInt(attr) : null;
                    return bytes === null || isNaN(bytes) ? 0 : bytes;
                },
            },
        };
    },
});
export const FileAttachmentList = Node.create({
    name: LIST_NODE_NAME,
    group: 'block',
    content: `${LIST_ITEM_NODE_NAME}*`,
    draggable: true,
    atom: true,
    addCommands() {
        return {
            addFileAttachmentsList: (files) => ({ commands }) => {
                return commands.insertContent({
                    type: this.name,
                    content: files.map((attrs) => ({
                        type: LIST_ITEM_NODE_NAME,
                        attrs,
                    })),
                });
            },
            showFileUploader: () => () => {
                this.options.showFileUploader();
                return true;
            },
        };
    },
    parseHTML() {
        return [
            {
                tag: LIST_TAG_NAME,
            },
        ];
    },
    renderHTML({ HTMLAttributes }) {
        return [LIST_TAG_NAME, mergeAttributes(HTMLAttributes), 0];
    },
});
//# sourceMappingURL=file-attachment.js.map